import type React from 'react';

// Shared by the utilization grid (UtilizationSection) and the operator week
// calendar (pages/assets/week), so "taken, but not firmly" looks the same on
// both.
//
// An unfirm block is HATCHED, on the same band — never a second row (#2634
// item 3). A row underneath would read as two things occupying one slot, i.e.
// double-booked; they are mutually exclusive — one occupant with a weak claim.
// Hatching on the block itself says "taken, but not firmly", which is the
// truth:
//
//     Saal A   ████████  ▨▨▨▨▨▨▨▨  ████████
//              gebucht   reserviert  gebucht
//
// A repeating-linear-gradient rather than an SVG pattern or a border: it scales
// with the 20px cell, costs no extra element inside a cell rendered up to
// 31 × 24 times, and layers over whichever primary-opacity step the fill
// already chose instead of replacing it — so the occupancy ramp still reads.
// Written inline because the angle and pitch are one value, not a token, and
// Tailwind has no arbitrary-gradient utility that survives the class scan.
//
// DARK stripes, not white. `cellClass` bottoms out at `bg-primary/15`, and the
// palest step is where a pool lands when a single unit is unfirm — one of ten
// boards reserved. White stripes read on a saturated cell and VANISH on that
// one, which is precisely the case the operator most needs to catch, since a
// lightly-booked week is the one they would otherwise read as free. A
// semi-transparent black reads across the whole ramp: dark-on-pale at the
// bottom, darker-on-colour at the top.
export const OCCUPANCY_HATCH: React.CSSProperties = {
    backgroundImage:
        'repeating-linear-gradient(45deg,' +
        ' rgba(0,0,0,0.32) 0px, rgba(0,0,0,0.32) 2px,' +
        ' rgba(0,0,0,0) 2px, rgba(0,0,0,0) 5px)',
};
